import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import { ChevronRight } from 'lucide-react';
import React__default from 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import { Link } from 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Navigation breadcrumb component
 * @param items - Breadcrumb items array
 * @param className - Additional CSS classes
 * @param separator - Custom separator element
 * @param maxItems - Maximum items to show before truncation
 * @returns JSX element with breadcrumb navigation
 */
const Breadcrumbs = ({ items, className, separator = jsx(ChevronRight, { className: "h-4 w-4" }), maxItems, }) => {
    // Handle truncation if maxItems is specified
    const displayItems = React__default.useMemo(() => {
        if (!maxItems || items.length <= maxItems) {
            return items;
        }
        const firstItem = items[0];
        const lastItems = items.slice(-(maxItems - 1));
        return [firstItem, { label: '...', current: false }, ...lastItems];
    }, [items, maxItems]);
    return (jsx("nav", { className: cn('flex items-center space-x-1 text-sm', className), "aria-label": "Breadcrumb", children: jsx("ol", { className: "flex items-center space-x-1", children: displayItems.map((item, index) => (jsxs("li", { className: "flex items-center", children: [index > 0 && (jsx("span", { className: "mx-2 text-muted-foreground", "aria-hidden": "true", children: separator })), item.label === '...' ? (jsx("span", { className: "text-muted-foreground", children: "..." })) : item.current || (!item.href && !item.onClick) ? (jsx("span", { className: "font-medium ", "aria-current": item.current ? 'page' : undefined, children: item.label })) : item.href ? (jsx(Link, { to: item.href, className: "font-medium text-muted-foreground hover:text-foreground transition-colors", children: item.label })) : (jsx("button", { onClick: item.onClick, className: "font-medium text-muted-foreground hover:text-foreground transition-colors", children: item.label }))] }, index))) }) }));
};

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.js.map
